
<div class="tabs-container d-none d-md-flex">
  <div
    class="tab"
    *ngFor="let tab of tabs"
    [ngClass]="{'active': currentUrl === tab.path}"
    (click)="navigateTo(tab.path)"
    [title]="tab.title">
    <i [class]="tab.icon"></i>&nbsp;{{ tab.title }}
    <i class="bi bi-x close-icon" (click)="closeTab(tab.path)"></i>
  </div>
</div>

